import getVal from './utils/getVal';

export default async function getGraph(url, type, query) {
  if (url && typeof url !== 'undefined' && type && typeof type !== 'undefined') {
    const endpoint = `${url}webcharts.com/graph.jpg/${type}`;
    const params = `?wcd=${getVal(query.wcd)}&wct=${getVal(query.wct)}&wcs=${getVal(query.wcs)}`;
    try {
      const response = await fetch(`${endpoint}${params}`, {
        method: 'GET',
      }).then((res) => res.blob());
      return response;
    } catch (error) {
      return null;
    }
  } else return null;
}

/* EXAMPLE:
const res = await getGraph('https://dev-calculator.morethanheight.com/uk/', 'Height', {
    wcd: 'M422230000000000439621100002000440541150002200',
});
*/
